var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    rate,
    rateAsJSON,
    loan_type,
    featured
  } = options;

__p+='\n\n<!-- Rate Card -->\n<div class="mrtg-rate-card pos-relative js-mrtg-rate-card" data="'+
((__t=( rateAsJSON ))==null?'':__t)+
'">\n  <div class="row offer">\n    <div class="col-xs-3">\n      ';
 if (rate.logo_path) {
__p+='\n        ';
 if (!rate.is_editorial) {
__p+='\n          <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="margin-bottom-sm" target="_blank" data-omtag=\'finance:mortgage-rate-table:lender\' rel=\'nofollow\'>\n            <img src="'+
((__t=( rate.logo_path ))==null?'':__t)+
'" class=\'lender-logo display-block\' alt="'+
((__t=( rate.advertiser ))==null?'':__t)+
'"/>\n          </a>\n        ';
} else {
__p+='\n          <img src="'+
((__t=( rate.logo_path ))==null?'':__t)+
'" class=\'lender-logo margin-bottom-sm display-block\' alt="'+
((__t=( rate.advertiser ))==null?'':__t)+
'"/>\n        ';
}
__p+='\n      ';
} else {
__p+='\n        <div class="lender margin-bottom">'+
((__t=( rate.advertiser ))==null?'':__t)+
'</div>\n      ';
}
__p+='\n      ';
 if (rate.mls_number) {
__p+='\n        <div class="nmls margin-right-sm">NMLS #'+
((__t=( rate.mls_number ))==null?'':__t)+
'</div>\n      ';
}
__p+='\n      ';
 if (rate.state_license) {
__p+='\n        <div class="state-license">State Lic #'+
((__t=( rate.state_license ))==null?'':__t)+
'</div>\n      ';
}
__p+='\n\n      ';
 if (!rate.is_editorial) {
__p+='\n        <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="margin-bottom-sm" target="_blank" data-omtag=\'finance:mortgage-rate-table:lender\' rel=\'nofollow\'>\n          More Details\n        </a>\n      ';
}
__p+='\n\n      ';
 if (rate.reviews && false) { 
__p+='\n      <div class="star-rating margin-bottom-lg">\n        ';
 stars = rate.reviews.stars 
__p+='\n        ';
 for(var i=0; i<5; i++) { 
__p+='\n          ';
 if (stars >= 1) { 
__p+='\n          <i class="ra ra-star"></i>\n          ';
 } else if (stars >= 0.5) { 
__p+='\n          <i class="ra ra-star-half"></i>\n          ';
 } else { 
__p+='\n          <i class="ra ra-star-o"></i>\n          ';
 } 
__p+='\n          ';
 stars-- 
__p+='\n        ';
 } 
__p+='\n        <span class="rating-reviews">('+
((__t=( rate.reviews.count ))==null?'':__t)+
')</span>\n      </div>\n      ';
 } 
__p+='\n    </div>\n    <div class="col-xs-3">\n      <span class="loan margin-bottom-sm">'+
((__t=( loan_type ))==null?'':__t)+
'</span>\n      <div class="margin-bottom-sm">\n        <a class="popover-rate" role="button" data-toggle="popover" tabindex="99" data-trigger="hover focus"\n           data-placement="top" data-content="The annual percentage rate (APR) is a number designed to help you evaluate the total cost of a loan. In addition to the interest rate, it takes into account the fees, rebates, and other costs you may encounter over the life of the loan.">\n          <div class="rate">'+
((__t=( rate.apr_val.toFixed(3) ))==null?'':__t)+
'% <span>APR</span></div>\n        </a>\n      </div>\n      <div class="margin-bottom-sm">\n        <a class="popover-rate" role="button" data-toggle="popover" tabindex="99" data-trigger="hover focus"\n      data-placement="top" data-content="Points, also known as “discount points,” are fees paid directly to the lender at closing in exchange for a reduced interest rate. This is also called “buying down the rate,” which can, in turn, lower your monthly mortgage payments."><span class="points-rate">'+
((__t=( rate.rate.toFixed(3) ))==null?'':__t)+
'%</span> at <span class="points">'+
((__t=( rate.points ))==null?'':__t)+
'</span> point</a>\n      </div>\n      <div class="muted">'+
((__t=( rate.date_val ))==null?'':__t)+
'</div>\n    </div>\n    <div class="col-xs-3">\n      <div class="monthly-payment-label margin-bottom-sm">Monthly Payment</div>\n      <div class="monthly-payment margin-bottom-sm">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(rate.loan_payment) ))==null?'':__t)+
'<span>/mo</span></div>\n      <div class="margin-bottom-sm">\n        <a class="popover-rate" role="button" data-toggle="popover" tabindex="99" data-trigger="hover focus"\n      data-placement="top" data-content="This includes several fees one needs to pay as part of getting a mortgage loan. Fees include things like application fee, rate lock fee, underwriting fee and loan processing fee."><span class="fee">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(rate.loan_fees) ))==null?'':__t)+
' fees</span></a>\n      </div>\n    </div>\n    <div class="col-xs-3">\n      ';
 if (!rate.is_editorial) {
__p+='\n        <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="btn btn-primary margin-bottom" target="_blank" data-omtag=\'finance:mortgage-rate-table:lender\' rel=\'nofollow\'>Next</a>\n      ';
}
__p+='\n      ';
 if (rate.phone_no) {
__p+='\n        <div class="lender-phone text-align-center">\n          <div class="phone" data-omtag="finance:mortgage-rate-table:phone">'+
((__t=( rate.phone_no ))==null?'':__t)+
'</div>\n          <span>Toll Free</span>\n        </div>\n      ';
}
__p+='\n    </div>\n  </div>\n  <div class=\'collapse\' id=\'collapse-rate-detail-'+
((__t=(rate.id))==null?'':__t)+
'\'></div>\n</div>\n<!-- End Rate Card -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_card.jst.ejs